<div class="step-header max-width">
  <h1 class="step-title">The Basics</h1>
  <p class="step-description">Tell us about yourself</p>
</div>

<ng-template #loading>
  <terra-loader />
</ng-template>

<form
  *ngIf="accountDetails$ | async as clientDetails; else loading"
  [formGroup]="pageForm"
  (ngSubmit)="nextStep(clientDetails.isRepresentingOrganization)"
  (keydown.enter)="$event.preventDefault()"
  class="terra-error-style"
>
  <div class="form-grid max-width">
    <!-- First Name -->
    <div class="terra-form-field-wrapper">
      <label for="txtFirstName" class="text-input-label">First & Middle name</label>
      <mat-form-field appearance="outline">
        <input matInput id="txtFirstName" formControlName="firstName" autocomplete="first-name" class="lo_sensitive" />
        <mat-error *ngIf="pageForm.get('firstName').hasError('required')"> Required </mat-error>
      </mat-form-field>
    </div>

    <!-- Last Name -->
    <div class="terra-form-field-wrapper new-row">
      <label for="txtLastName" class="text-input-label">Last name</label>
      <mat-form-field appearance="outline">
        <input matInput id="txtLastName" formControlName="lastName" autocomplete="last-name" class="lo_sensitive" />
        <mat-error *ngIf="pageForm.get('lastName').hasError('required')"> Required </mat-error>
      </mat-form-field>
    </div>

    <!-- Phone number -->
    <terra-phone formControlName="phone1" [isSubmitted]="isSubmitted" class="new-row">
      <label for="txtPhone" class="text-input-label">Phone</label>
      <mat-error *ngIf="pageForm.get('phone1').hasError('required')">Required</mat-error>
    </terra-phone>

    <ng-container *ngIf="!clientDetails.isRepresentingOrganization">
      <!-- Country -->
      <div class="terra-form-field-wrapper new-row">
        <label for="aucCountryId" class="text-input-label">Country of residence</label>
        <terra-country-auto-complete
          inputId="aucCountryId"
          controlName="countryId"
          placeholderText="Select country"
          [countriesList]="allCountries"
          />
      </div>
      <!-- State -->
      <div class="terra-form-field-wrapper new-row" *ngIf="pageForm.get('countryId').value === USCountryId">
        <label for="ddlStateName" class="text-input-label">State</label>
        <mat-form-field appearance="outline">
          <mat-select formControlName="stateName" id="ddlStateName" placeholder="Select">
            <mat-option *ngFor="let stateOption of allStates" [value]="stateOption.name"> {{ stateOption.name }} </mat-option>
          </mat-select>
          <mat-error *ngIf="pageForm.get('stateName').hasError('required')"> Required </mat-error>
        </mat-form-field>
      </div>
    </ng-container>

    <!-- Error message -->
    <div *ngIf="isSubmitted" class="full-width">
      <p *ngIf="pageForm.invalid" class="error-message">
        Please review and correct the fields marked in red
      </p>
      <p *ngIf="isGeneralServerError" class="error-message">{{ generalServerErrorMessage }}</p>
    </div>

    <div class="form-actions full-width">
      <button type="submit" class="page-cta half-width tall-button" color="primary" mat-flat-button *ngIf="clientDetails.isRepresentingOrganization">
        Next
        <mat-icon class="notranslate">keyboard_arrow_right</mat-icon>
      </button>
      <button
        type="submit"
        [disabled]="formSubmitting"
        class="page-cta half-width tall-button"
        color="primary"
        mat-flat-button
        *ngIf="!clientDetails.isRepresentingOrganization"
      >
        <span>Create Account</span>
        <terra-loader *ngIf="formSubmitting" />
      </button>
    </div>
      
      <button
        class="page-cta half-width tall-button"
        color="secondary"
        mat-flat-button
        (click) ="clientDetails.isRepresentingOrganization ? swtichAccountTypeToIndividual() : swtichAccountTypeToOrganization()">
        {{ clientDetails.isRepresentingOrganization ? 'Switch to Personal Account' : 'Switch to Business Account' }}
      </button>
  </div>


</form>
